export default "/images/85943d0b131bbf1414def8cfe7f44da8.avif";